export default __webpack_public_path__ + "static/media/fruitjelly@3x.e2ce1667.jpg";